<template>
    <Protect v-if="!person?.license" />
    <div class="main-content">
        <div class="discovered">
            <PhCheckCircle :size="20" :class="discoveredIconClass" weight="fill" />
            <span :class="discoveredTextClass">Discovered</span>
        </div>
        <div class="horizontal-div"></div>
        <div class="progress">
            <svg
                v-if="currentStep() === 2"
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                class="spinner"
            >
                <path
                    d="M11.25 1.125V4.125C11.25 4.42337 11.1315 4.70952 10.9205 4.9205C10.7095 5.13147 10.4234 5.25 10.125 5.25C9.82663 5.25 9.54048 5.13147 9.3295 4.9205C9.11853 4.70952 9 4.42337 9 4.125V1.125C9 0.826631 9.11853 0.540483 9.3295 0.329505C9.54048 0.118526 9.82663 0 10.125 0C10.4234 0 10.7095 0.118526 10.9205 0.329505C11.1315 0.540483 11.25 0.826631 11.25 1.125ZM19.125 9H16.125C15.8266 9 15.5405 9.11853 15.3295 9.3295C15.1185 9.54048 15 9.82663 15 10.125C15 10.4234 15.1185 10.7095 15.3295 10.9205C15.5405 11.1315 15.8266 11.25 16.125 11.25H19.125C19.4234 11.25 19.7095 11.1315 19.9205 10.9205C20.1315 10.7095 20.25 10.4234 20.25 10.125C20.25 9.82663 20.1315 9.54048 19.9205 9.3295C19.7095 9.11853 19.4234 9 19.125 9ZM15.1631 13.5722C15.0585 13.4675 14.9342 13.3845 14.7975 13.3279C14.6608 13.2713 14.5142 13.2421 14.3663 13.2421C14.2183 13.2421 14.0717 13.2713 13.935 13.3279C13.7983 13.3845 13.674 13.4675 13.5694 13.5722C13.4647 13.6768 13.3817 13.8011 13.3251 13.9378C13.2684 14.0745 13.2393 14.2211 13.2393 14.3691C13.2393 14.5171 13.2684 14.6636 13.3251 14.8003C13.3817 14.9371 13.4647 15.0613 13.5694 15.1659L15.6909 17.2875C15.9023 17.4988 16.1889 17.6176 16.4878 17.6176C16.7867 17.6176 17.0733 17.4988 17.2847 17.2875C17.496 17.0762 17.6148 16.7895 17.6148 16.4906C17.6148 16.1917 17.496 15.9051 17.2847 15.6937L15.1631 13.5722ZM10.125 15C9.82663 15 9.54048 15.1185 9.3295 15.3295C9.11853 15.5405 9 15.8266 9 16.125V19.125C9 19.4234 9.11853 19.7095 9.3295 19.9205C9.54048 20.1315 9.82663 20.25 10.125 20.25C10.4234 20.25 10.7095 20.1315 10.9205 19.9205C11.1315 19.7095 11.25 19.4234 11.25 19.125V16.125C11.25 15.8266 11.1315 15.5405 10.9205 15.3295C10.7095 15.1185 10.4234 15 10.125 15ZM5.08687 13.5722L2.96531 15.6937C2.75397 15.9051 2.63524 16.1917 2.63524 16.4906C2.63524 16.7895 2.75397 17.0762 2.96531 17.2875C3.17666 17.4988 3.4633 17.6176 3.76219 17.6176C4.06107 17.6176 4.34772 17.4988 4.55906 17.2875L6.68062 15.1659C6.89197 14.9546 7.0107 14.6679 7.0107 14.3691C7.0107 14.0702 6.89197 13.7835 6.68062 13.5722C6.46928 13.3608 6.18264 13.2421 5.88375 13.2421C5.58486 13.2421 5.29822 13.3608 5.08687 13.5722ZM5.25 10.125C5.25 9.82663 5.13147 9.54048 4.9205 9.3295C4.70952 9.11853 4.42337 9 4.125 9H1.125C0.826631 9 0.540483 9.11853 0.329505 9.3295C0.118526 9.54048 0 9.82663 0 10.125C0 10.4234 0.118526 10.7095 0.329505 10.9205C0.540483 11.1315 0.826631 11.25 1.125 11.25H4.125C4.42337 11.25 4.70952 11.1315 4.9205 10.9205C5.13147 10.7095 5.25 10.4234 5.25 10.125ZM4.55625 2.96531C4.34491 2.75397 4.05826 2.63524 3.75937 2.63524C3.46049 2.63524 3.17384 2.75397 2.9625 2.96531C2.75116 3.17666 2.63242 3.4633 2.63242 3.76219C2.63242 4.06107 2.75116 4.34772 2.9625 4.55906L5.08687 6.67781C5.29822 6.88916 5.58486 7.00789 5.88375 7.00789C6.18264 7.00789 6.46928 6.88916 6.68062 6.67781C6.89197 6.46647 7.0107 6.17982 7.0107 5.88094C7.0107 5.58205 6.89197 5.29541 6.68062 5.08406L4.55625 2.96531Z"
                    fill="#2563F3"
                />
            </svg>
            <PhCheckCircle v-else :size="20" :class="progressIconClass" weight="fill" />
            <span :class="progressTextClass">
                <span>In Progress</span>
            </span>
        </div>
        <div class="horizontal-div"></div>
        <div class="clear">
            <PhWarningCircle v-if="currentStep() >= 3 && isFailed" :size="20" :class="failedIconClass" weight="fill" />
            <PhCheckCircle v-else :size="20" :class="clearIconClass" weight="fill" />
            <span :class="{ completed: currentStep() >= 3 && !isFailed, failed: currentStep() >= 3 && isFailed, inactive: currentStep() < 3 }">Closed</span>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ExposureStatus } from '~/types/person/details';
import Protect from './Protect.vue';

const store = usePersonStore();
const { person } = storeToRefs(store);

interface Props {
    exposure: any;
}
const props = defineProps<Props>();

const currentStep = () => {
    const status = props.exposure?.status;
    if (!status) return 1;

    // Handle both enum and string values
    if (status === ExposureStatus.PENDING || status === 'pending') return 1;
    if (status === ExposureStatus.IN_PROGRESS || status === 'in_progress') return 2;
    if (status === ExposureStatus.CLOSED || status === 'closed') return 3;
    if (status === ExposureStatus.FAILED || status === 'failed') return 3;
    return 1;
};

// Discovered section classes
const discoveredIconClass = computed(() => {
    return currentStep() >= 1 ? 'text-green-600' : 'text-zinc-300';
});

const discoveredTextClass = computed(() => {
    return currentStep() >= 1 ? '' : '!text-zinc-300';
});

// Removal in Progress section classes
const progressIconClass = computed(() => {
    return currentStep() >= 2 ? 'text-green-600' : 'text-zinc-300';
});

const progressTextClass = computed(() => {
    if (currentStep() === 2) return '!text-blue-600';
    if (currentStep() === 3) return '';
    return '!text-zinc-300';
});

// All Clear section classes
const failedIconClass = computed(() => {
    return currentStep() === 3 ? 'text-red-600' : 'text-zinc-300';
});

const clearIconClass = computed(() => {
    return currentStep() === 3 ? 'text-green-600' : 'text-zinc-300';
});

// Check if exposure status is failed
const isFailed = computed(() => {
    const status = props.exposure?.status;
    return status === ExposureStatus.FAILED || status === 'failed';
});
</script>
<style lang="scss" scoped>
.main-content {
    @apply flex items-center self-stretch gap-2 border-t border-zinc-300 bg-zinc-50 px-6 py-2;
}
.discovered,
.progress,
.clear {
    @apply flex items-center gap-2 flex-1;

    span {
        @apply font-inter text-sm font-medium whitespace-nowrap;
    }
}
.horizontal-div {
    @apply h-px bg-zinc-400 flex-1;
}

.spinner {
    animation: spin 2s linear infinite;
}

.completed {
    @apply text-zinc-950;
}

.failed {
    @apply text-red-600;
}
.inactive {
    @apply text-zinc-300;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
